import { render } from "./AppControl.vue?vue&type=template&id=4687bea3"
import script from "./AppControl.vue?vue&type=script&lang=js"
export * from "./AppControl.vue?vue&type=script&lang=js"

import "./AppControl.vue?vue&type=style&index=0&id=4687bea3&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__